import { Grid, Box } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";

interface ActionsCardProps {
  icon: any;
  text: string;
}

export function ActionsCard({ icon: Icon, text }: ActionsCardProps) {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        bgcolor="#f4f4f4db"
        borderRadius="1rem"
        p={1.6}
        alignItems="center"
        textAlign="center"
        height="100%"
        sx={{ overflowY: "hidden" }}
      >
        <Icon style={{ width: "5rem", height: "5rem" }} />
        <MxTypography color="#3f3f3f" fontWeight={400}>
          {text}
        </MxTypography>
      </Box>
    </Grid>
  );
} 